// HACK - import Buffer to client side
// Needed for ulid-uuid-converter used in composables/useApiIdConverter.ts
import { Buffer } from 'buffer'

window.Buffer = Buffer
export default defineNuxtPlugin({})